import Vue from 'vue';
import {
  capitalize,
  formatDate,
  formatTime,
  numberToWordsOrdinal,
  daysRemaining
} from '@/utils';


Vue.filter('capitalize', capitalize);

Vue.filter('formatDate', formatDate);
Vue.filter('formatTime', formatTime);

Vue.filter('numberToWordsOrdinal', numberToWordsOrdinal);

Vue.filter('daysRemaining', daysRemaining);